// CONFLICT: copied from react project because it had one more .replace method

export const toSlugCase = (str) => {
  return String(str)
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .map((n) => n.toLowerCase().replace(/[^a-z0-9]/g, ''))
    .join('-');
};
